import { render, staticRenderFns } from "./EscrowModal.vue?vue&type=template&id=f04ae60c&scoped=true&"
import script from "./EscrowModal.vue?vue&type=script&lang=js&"
export * from "./EscrowModal.vue?vue&type=script&lang=js&"
import style0 from "./EscrowModal.vue?vue&type=style&index=0&id=f04ae60c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04ae60c",
  null
  
)

export default component.exports